import { Select } from '../../Select'

export const Option = Select.Option
